export enum OloOrderHistorySource {
  RecentProducts = 'recent-products',
  RecentOrders = 'recent-orders',
}
